module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mains"
  }, [_c('div', {
    staticClass: "pic mar1"
  }, [_c('div', {
    staticClass: "desc"
  }, [_c('h3', [_vm._v("关于我们")]), _vm._v(" "), _c('p', {
    staticClass: "word",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "imgs",
    attrs: {
      "src": _vm.src2
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dcfc200"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/homeContent.vue
// module id = 161
// module chunks = 1